var map = {
	"./amplify-amazon-button_5.entry.js": [
		1091,
		7
	],
	"./amplify-auth-fields_9.entry.js": [
		1092,
		8
	],
	"./amplify-authenticator.entry.js": [
		1093,
		9
	],
	"./amplify-button_3.entry.js": [
		1094,
		10
	],
	"./amplify-checkbox.entry.js": [
		1095,
		11
	],
	"./amplify-confirm-sign-in_8.entry.js": [
		1096,
		12
	],
	"./amplify-container.entry.js": [
		1097,
		13
	],
	"./amplify-federated-buttons_2.entry.js": [
		1098,
		14
	],
	"./amplify-federated-sign-in.entry.js": [
		1099,
		15
	],
	"./amplify-form-field_4.entry.js": [
		1100,
		16
	],
	"./amplify-greetings.entry.js": [
		1101,
		17
	],
	"./amplify-icon-button.entry.js": [
		1102,
		18
	],
	"./amplify-icon.entry.js": [
		1103,
		4
	],
	"./amplify-link.entry.js": [
		1104,
		19
	],
	"./amplify-nav_2.entry.js": [
		1105,
		20
	],
	"./amplify-radio-button_2.entry.js": [
		1106,
		21
	],
	"./amplify-select-mfa-type.entry.js": [
		1107,
		22
	],
	"./amplify-sign-in-button.entry.js": [
		1108,
		5
	],
	"./amplify-tooltip.entry.js": [
		1109,
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 801;
module.exports = webpackAsyncContext;